import { useRecoilState, useSetRecoilState } from "recoil";
import {
  errorsReservationGuestState,
  valuesFormReservationGuestImagenologiaState,
  valuesFormReservationGuestState,
} from "src/Patient/state/atoms";
import { InputAdornment, InputLabel, SvgIcon, TextField } from "@mui/material";
import {
  cleanRut,
  formatRut,
  validateRutChilean,
} from "src/shared/global/helpers";
import EspecialistaIcon from "src/shared/icons/EspecialistaIcon";

export const InputRut = ({ styles }) => {
  const [errorsReservationGuest, setErrorsReservationGuest] = useRecoilState(
    errorsReservationGuestState
  );
  const [valuesFormReservationGuest, setValuesFormReservationGuest] =
    useRecoilState(valuesFormReservationGuestState);
  const [
    valuesFormReservationGuestImagenologia,
    setValuesFormReservationGuestImagenologia,
  ] = useRecoilState(valuesFormReservationGuestImagenologiaState);

  const handleChange = (ev) => {
    let { name, value } = ev.target;
    if (errorsReservationGuest.hasOwnProperty(name)) {
      setErrorsReservationGuest({ ...errorsReservationGuest, [name]: [] });
    }

    if (name === "uprRut") {
      value = formatRut(cleanRut(value));

      if (value === "" || value === undefined) {
        value = null;
      }
      const isValid = validateRutChilean(value);
      
      if (!isValid.ok) {
        setErrorsReservationGuest({
          ...errorsReservationGuest,
          [name]: ["Ingrese un RUT válido"],
        });
      }
    }

    if (value === undefined) value = "";

    setValuesFormReservationGuest({
      ...valuesFormReservationGuest,
      [name]: value,
    });
    setValuesFormReservationGuestImagenologia({
      ...valuesFormReservationGuestImagenologia,
      [name]: value,
    });
  };

  const nuevoBuscador = window.location.pathname.indexOf("nuevo-buscar") >= 0;
  const viejoBuscador = window.location.pathname.indexOf("buscar") >= 0;
  return (
    <>
      <InputLabel
        htmlFor="input-rut"
        sx={{
          textOverflow: "clip",
          whiteSpace: "nowrap",
          overflow: "hidden",
          display: "block",
          width: "100%",
          marginBottom: "5px",
          fontSize: "13px",
          ...styles.label,
        }}
      >
        RUT Paciente (Invitado) o{" "}
        <a
          href={`${process.env.REACT_APP_ROOT_SERVER_PATH}/login`}
          style={{
            ...styles.label,
            textDecoration: "underline",
          }}
          target={nuevoBuscador || viejoBuscador ? "blank" : "_self"}
        >
          Inicie Sesión
        </a>
      </InputLabel>
      <TextField
        size="small"
        id="input-rut"
        error={
          errorsReservationGuest["uprRut"] &&
          errorsReservationGuest["uprRut"].length > 0
            ? true
            : false
        }
        helperText={
          errorsReservationGuest["uprRut"] &&
          errorsReservationGuest["uprRut"].length > 0
            ? `${errorsReservationGuest["uprRut"].join("\n")}`
            : ""
        }
        sx={{
          width: "100%",
          "& .MuiInputBase-input": {
            ...styles.input,
          },
          ...styles.autocomplete,
          input: {
            ...styles.texfield,
          },
        }}
        name="uprRut"
        type="text"
        value={
          valuesFormReservationGuest.uprRut ||
          valuesFormReservationGuestImagenologia.uprRut ||
          ""
        }
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          maxLength: 12,
          startAdornment: (
            <InputAdornment
              position="start"
              sx={{
                display: nuevoBuscador ? "" : "none",
              }}
            >
              {nuevoBuscador && (
                <SvgIcon sx={{ fontSize: "15px" }}>
                  <EspecialistaIcon />
                </SvgIcon>
              )}
            </InputAdornment>
          ),
        }}
        variant="outlined"
        onChange={handleChange}
        autoComplete="off"
        placeholder={
          nuevoBuscador
            ? "Rut Paciente (invitado) o Inicie Sesión"
            : "Ej: 16.000.000-0"
        }
      />
    </>
  );
};
